/* 4500 only: native variant selection remains the single source of truth. */
(() => {
  if (!document.querySelector('[data-m4500-intro]') || window.m4500BuyingReady) return;
  window.m4500BuyingReady = true;
  const groups = [
    ['すべて', ''], ['白・生成り', '100 101 111'], ['青・紺', '103 106 118 119 124 203 218 219 220 221 319'],
    ['緑', '105 115 125 126 129 205 206 212 214 215 224 225 325'], ['ピンク・赤', '102 109 117 121 122 127 202 217 222'],
    ['黄・オレンジ', '104 114 204 207 223'], ['茶・ベージュ', '107 116 127 207 212 213 216'], ['グレー', '108 120 128 208 209 320'], ['紫', '110 123 210 211 323']
  ];
  let query = '', group = '', returnFocus = null, expanded = false;
  const normalize = s => String(s).normalize('NFKC').toLowerCase().replace(/[\s#＃]/g, '');
  const mainPicker = () => document.querySelector('variant-picker[handle="4500"][context="main_product"]');
  function filter(picker) {
    if (!picker) return;
    const tokens = query.normalize('NFKC').trim().split(/\s+/).filter(Boolean).map(normalize);
    const codes = group.split(' ');
    const cards = [...picker.querySelectorAll('.fabric-variant-card')];
    const matches = cards.filter(card => {
      const code = normalize(card.querySelector('.fabric-variant-card__code')?.textContent || '');
      return (!group || codes.includes(code)) && tokens.every(t => normalize(card.textContent).includes(t));
    });
    const folding = innerWidth < 700 && !expanded && matches.length > 12;
    const shown = folding ? matches.slice(0,12) : matches;
    const selected = matches.find(card => document.getElementById(card.htmlFor)?.checked);
    if(folding && selected && !shown.includes(selected)) shown[shown.length-1]=selected;
    const visibleCards = new Set(shown);
    cards.forEach(card => {
      const hidden = !visibleCards.has(card);
      card.classList.toggle('m4500-filtered', hidden);
      document.getElementById(card.htmlFor)?.classList.toggle('m4500-filtered', hidden);
    });
    const count=matches.length;
    const status = picker.querySelector('.m4500-color-status');
    if (status) status.textContent = `${shown.length}色を表示 / ${group ? '該当' : '全'}${matches.length}色`;
    const toggle = picker.querySelector('[data-m4500-expand]');
    if(toggle){toggle.hidden=innerWidth>=700||matches.length<=12;toggle.textContent=expanded?'色一覧をコンパクトにする':`残りの色も見る（${matches.length}色）`;toggle.setAttribute('aria-expanded',String(expanded));}
    const empty = picker.querySelector('.m4500-empty');
    if (empty) empty.hidden = count > 0;
    picker.querySelectorAll('[data-m4500-group]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.m4500Group === group)));
  }

  function mountNativeLengths() {
    const select=document.querySelector('.product-info .qty-x50-select[form^="product-form-main"]');
    if(!select)return;
    const summary=select.closest('.qty-x50-summary');if(!summary)return;
    let shortcuts=summary.querySelector('.m4500-native-lengths');
    if(!shortcuts){
      shortcuts=document.createElement('div');shortcuts.className='m4500-native-lengths';shortcuts.setAttribute('role','group');shortcuts.setAttribute('aria-label','購入する長さを選ぶ');
      for(const [units,label] of [[1,'0.5m'],[2,'1m'],[3,'1.5m'],[4,'2m']]){
        const button=document.createElement('button');button.type='button';button.textContent=label;button.dataset.units=String(units);
        button.addEventListener('click',()=>{if(button.disabled)return;select.value=String(units);select.dispatchEvent(new Event('change',{bubbles:true}));mountNativeLengths();});shortcuts.append(button);
      }
      summary.querySelector('.qty-x50-stepper').before(shortcuts);
    }
    let help = summary.querySelector('[data-m4500-length-help]');
    if (!help) {
      help = document.createElement('p'); help.dataset.m4500LengthHelp = 'true';
      help.textContent = 'ボタンで長さを選び、＋・−で0.5mずつ調整できます。';
      help.style.cssText = 'font-size:14px;line-height:1.8;color:#707070;margin:8px 0';
      shortcuts.after(help);
    }
    shortcuts.querySelectorAll('button').forEach(button=>{
      const option=[...select.options].find(o=>o.value===button.dataset.units);
      button.disabled=select.disabled||!option||option.disabled||Number(button.dataset.units)>Number(select.dataset.maxQuantity||Infinity);
      button.setAttribute('aria-pressed',String(select.value===button.dataset.units));
    });
  }
  document.addEventListener('change',e=>{if(e.target.matches?.('.product-info .qty-x50-select'))mountNativeLengths();});

  function mount() {
    mountNativeLengths();
    const picker = mainPicker();
    if (!picker) return;
    picker.id = 'm4500-color-picker';
    if (!picker.querySelector('.m4500-colors')) {
      const box = document.createElement('div');
      box.className = 'm4500-colors';
      box.innerHTML = '<div class="m4500-color-groups" aria-label="色の系統で絞り込む"></div><p class="m4500-color-status" role="status" aria-live="polite"></p><p class="m4500-empty" hidden>該当する色がありません。「すべて」で全色に戻せます。</p>';
      for (const [name,codes] of groups) {
        const button = document.createElement('button'); button.type = 'button';button.textContent = name;button.dataset.m4500Group=codes;
        box.querySelector('.m4500-color-groups').append(button);
      }
      picker.querySelector('.fabric-variant-card-grid')?.before(box);

      box.addEventListener('input', e => {if(e.target.id !== 'm4500-color-search')return;query=e.target.value;filter(picker);});
      box.addEventListener('click', e => {
        const b=e.target.closest('button');if(!b)return;
        if(b.hasAttribute('data-m4500-reset')){query='';group='';}
        else if(b.hasAttribute('data-m4500-group')){group=b.dataset.m4500Group;query='';expanded=false;}
        filter(picker);
      });
    }
    if(!picker.querySelector('[data-m4500-expand]')){
      const actions=document.createElement('div');actions.className='v-stack gap-3';actions.style.marginTop='16px';
      const toggle=document.createElement('button');toggle.type='button';toggle.dataset.m4500Expand='';toggle.className='link';
      toggle.addEventListener('click',()=>{expanded=!expanded;filter(picker);});actions.append(toggle);
      const next=document.createElement('button');next.type='button';next.className='button w-full';next.dataset.m4500Next='';next.textContent='この色の長さを選ぶ';
      next.style.cssText='background:#F29600;color:#fff;border-radius:0';
      next.addEventListener('click',()=>{
        const target=document.querySelector('.product-info .qty-x50-summary');if(!target)return;
        const top=Math.max(155,...[...document.querySelectorAll('x-header,.kiji-mobile-search')].map(n=>n.getBoundingClientRect().bottom).filter(n=>n>0&&n<innerHeight/2));
        window.scrollTo({top:scrollY+target.getBoundingClientRect().top-top-12,behavior:'smooth'});
        target.querySelector('.m4500-native-lengths button:not(:disabled)')?.focus({preventScroll:true});
      });actions.append(next);picker.append(actions);
    }
    filter(picker);
  }
  window.addEventListener('resize',()=>filter(mainPicker()));
  document.addEventListener('variant:change', e => {
    if(e.detail?.variant?.product_id && String(e.detail.variant.product_id)!=='10314331128101')return;
    if(!e.target.matches?.('form[id^="product-form-main"]'))return;
    const v=e.detail?.variant;
    if(v && document.querySelector('[data-m4500-price]'))document.querySelector('[data-m4500-price]').textContent=`${Math.round(v.price/100).toLocaleString('ja-JP')}円`;
    mount();
  });
  document.addEventListener('click', e => {
    const jump=e.target.closest('a[href="#m4500-color-picker"]');
    if(jump){const picker=mainPicker();if(picker){e.preventDefault();const headers=[...document.querySelectorAll('x-header,.kiji-mobile-search')];const top=Math.max(155,...headers.map(n=>n.getBoundingClientRect().bottom).filter(n=>n>0&&n<innerHeight/2));window.scrollTo({top:window.scrollY+picker.getBoundingClientRect().top-top-12,behavior:'smooth'});}}
    const opener=e.target.closest('.kiji-mobile-atc__actions button');
    if(opener){returnFocus=opener;requestAnimationFrame(()=>{const sheet=document.querySelector('.kiji-mobile-atc__sheet[aria-hidden="false"]');sheet?.querySelector('.kiji-mobile-atc__close')?.focus({preventScroll:true});});}
    if(e.target.closest('.kiji-mobile-atc__close,.kiji-mobile-atc__backdrop'))returnFocus?.focus({preventScroll:true});
  });
  document.addEventListener('keydown', e => {
    const sheet=document.querySelector('.kiji-mobile-atc__sheet[aria-hidden="false"]');if(!sheet)return;
    if(e.key==='Escape'){e.preventDefault();sheet.querySelector('.kiji-mobile-atc__close')?.click();return;}
    if(e.key!=='Tab')return;
    const focusable=[...sheet.querySelectorAll('button:not(:disabled),select:not(:disabled),input:not(:disabled),a[href],[tabindex="0"]')].filter(n=>n.getClientRects().length);
    const first=focusable[0],last=focusable.at(-1);if(!first)return;
    if(e.shiftKey && (document.activeElement===first||!sheet.contains(document.activeElement))){e.preventDefault();last.focus();}
    else if(!e.shiftKey && (document.activeElement===last||!sheet.contains(document.activeElement))){e.preventDefault();first.focus();}
  });
  mount();
})();
